export const readFileAsDataUrlWithProgress = (file, onProgress) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        onProgress(Math.max(0, Math.min(100, Math.round((event.loaded / event.total) * 100))));
      }
    };
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Dosya okunamadı'));
    reader.readAsDataURL(file);
  });

export const xhrProgressPercent = (event, fallback = 0) => {
  if (!event?.total) return fallback;
  return Math.max(0, Math.min(100, Math.round((event.loaded / event.total) * 100)));
};

export const optimizeImageFile = async (file) => {
  // Gecici: tum istemci tarafi goruntu sikistirma/yeniden encode islemleri kapali.
  return file;
};
